module.exports = __webpack_public_path__ + "img/GH-kyujin-top-h-pa-3sp.a75e5206.webp";